import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

export const getResultPermissionRole = async ({ token }) => {
  try {
    return await clientPublic
      .get('permission?kind=role', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
